let WidgetsList: any[] = [
    {
        widgetId: 'EE6F4ACE-B8EA-440D-B6C7-C7E111956F2F',
        widgetName: 'Dispatch Status Gauge',
        widgetType: 'Dispatch',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'dispatchStatusGauge-widget',
        rowColSpan: {
            rowSpan: 1,
            colSpan: 1
        }
    },
    {
        widgetId: 'BE10C991-25DE-468F-B784-AEC946613AAE',
        widgetName: 'Open Contracts',
        widgetType: 'Dispatch',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'openContracts-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '7F2A3B4C-5D6E-4F70-8901-23456789ABCD',
        widgetName: 'Pending Change Orders',
        widgetType: 'Dispatch',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'pendingChangeOrders-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '0C194118-A2EA-4EC0-95D3-B26E6B7C071D',
        widgetName: 'Open Dispatches',
        widgetType: 'Dispatch',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'openDispatches-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '603A6989-5C99-4EF1-8061-2D34A870F0CC',
        widgetName: 'Dispatch Review Lite',
        widgetType: 'Dispatch',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'dispatchReview-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },

    {
        widgetId: '4F98BB3D-B587-45A2-8672-0863F6A0B75A',
        widgetName: 'Order Review Lite',
        widgetType: 'Order',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'orderReview-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: 'FD0599A4-3504-41F3-825E-A1823B5C1ACC',
        widgetName: 'Credit Memo Approval',
        widgetType: 'Invoice',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'orderReview-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '44C61ABA-7768-4031-A924-57F0960B5018',
        widgetName: 'Dispatch Refrigerant Tracking',
        widgetType: 'Dispatch',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'dispatchRefTrack-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 1,
            colSpan: 1
        }
    },
    {
        widgetId: '15EBD17B-90E2-4BA3-8927-625E380001D0',
        widgetName: 'Active Invoice Dispute',
        widgetType: 'Invoice',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'dispatchRefTrack-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '3A19E42D-A5E3-4251-A4A6-256B42EF0C3B',
        widgetName: 'Open Quotes',
        widgetType: 'Quotes',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'openQuotes-widget',
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: 'E898452A-4252-4386-BEC9-0A54999ABC47',
        widgetName: 'Quotes Pending Approval',
        widgetType: 'Quotes',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'quotesPendingApproval-widget',
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: 'CBB135F5-BE58-42C2-987C-BF1A8F87B703',
        widgetName: 'Construction Month End Draw Re-Cost',
        widgetType: 'Invoice',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'monthEndDrawRecost-widget',
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '21C269B7-E19C-404E-A5D3-BAADABB22BAF',
        widgetName: 'Invoice Approval',
        widgetType: 'Invoice',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'invoiceApproval-widget',
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '560ABA99-0C32-4C8E-8792-E952757E6896',
        widgetName: 'Invoice Sales Summary',
        widgetType: 'Invoice',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'invoiceSalesSummary-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: '10DA21A9-4FE2-43B2-97FB-05CAB77F483C',
        widgetName: 'Monthly Invoice Sales Detail',
        widgetType: 'Invoice',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'monthyInvoiceSalesDetail-widget',
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    }
    ,{
        widgetId: '41C4D43D-73DB-43C2-BF0B-4E402163CD3B',
        widgetName: 'Tech Hours Summary',
        widgetType: 'Employee',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'techHoursSummary-widget',
        chartOptions: {
            chartType: 'column'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: 'CFFE2637-F934-4B4F-978F-F3DEE14A7ADF',
        widgetName: 'Tech Stat Summary',
        widgetType: 'Employee',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'techStatSummary-widget',
        chartOptions: {
            chartType: 'multi'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    }
    ,{
        widgetId: '2475BB0F-D0C0-455A-8267-F2E2D015779F',
        widgetName: 'Show Customer Statistics',
        widgetType: 'Sales',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'customerStats-widget',
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    },
    {
        widgetId: 'E8603350-9C84-4601-B829-CEB2B3CD4B31',
        widgetName: 'CP Dispatches Needing Parts',
        widgetType: 'Dispatch',
        preview: 'view',
        size: 1,
        minimized: 2,
        fullscreen: 1,
        customClass: 'zuggitCpDispatchNeedsParts-widget',
        chartOptions: {
            chartType: 'donut'
        },
        rowColSpan: {
            rowSpan: 3,
            colSpan: 1
        }
    }
];
export default WidgetsList;
